import React from "react";
import noData from "../../../assets/lotties/guidePageNoData.json";
import Lottie from "react-lottie";

const noDataJSON = {
  loop: false,
  autoplay: true,
  animationData: noData,
  // rendererSettings: {
  //   preserveAspectRatio: "xMidYMid slice",
  // },
};

function MockGuidePageNoData() {
  return (
    <div className="mt-3">
      <Lottie style={{ maxWidth: "240px" }} options={noDataJSON} />
      <div className="text-[#475467] text-[1.05rem] font-semibold text-center mx-auto mt-[-1rem]">
        No job guides found.
      </div>
    </div>
  );
}

export default MockGuidePageNoData;
